import { render, staticRenderFns } from "./RepresentativeDeliveries.vue?vue&type=template&id=b0b7576a&"
import script from "./RepresentativeDeliveries.vue?vue&type=script&lang=js&"
export * from "./RepresentativeDeliveries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports